import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=792b594a"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"
import style0 from "./Package.vue?vue&type=style&index=0&id=792b594a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports